import { ApolloLink } from '@apollo/client'

/**
 * @private only to be used in apolloClient.ts
 */
export const recaptchaLink = new ApolloLink((operation, forward) => {
  operation.setContext((ctx: { recaptchaToken: string; headers: Record<string, string> }) => {
    if (!ctx.recaptchaToken) {
      return {
        headers: {
          ...(ctx.headers || {}),
        },
      }
    }

    return {
      headers: {
        ...(ctx.headers || {}),
        'x-vhc': ctx?.recaptchaToken,
      },
    }
  })
  return forward(operation)
})
